import { PaymentMethod as PaymentMethodApi } from '@dreryk/egabinet-invoice-frontend-api';

import { assertUnreachable } from '@dreryk/react-common';

import { PaymentMethod } from '../shared/form/payment/payment.types';
import { visitSettlementTranslationKeys } from '../translations';

const t = visitSettlementTranslationKeys.paymentModal;

type GetLabelForVisitSettlementPaymentActionsReturn = {
   settlement: string;
   invoice: string | null;
};

export const getLabelForVisitSettlementPaymentActions = (
   ownedByCurrentUser: boolean,
   paymentEnabled: boolean
): GetLabelForVisitSettlementPaymentActionsReturn => {
   if (!paymentEnabled) {
      return { settlement: t.confirm.save, invoice: null };
   }

   return ownedByCurrentUser
      ? { settlement: t.confirm.saveAndSettle, invoice: t.confirm.settleAndCreateInvoice }
      : { settlement: t.confirm.confirm, invoice: t.confirm.confirmAndCreateInvoice };
};

export const mapFormBeanPaymentMethodToApiPaymentMethod = (paymentMethod: PaymentMethod): PaymentMethodApi => {
   switch (paymentMethod) {
      case 'cash':
         return 'CASH';
      case 'paymentCard':
         return 'CARD';
      case 'bankTransfer':
         return 'TRANSFER';
      case 'other':
         return 'OTHER';
      default:
         return assertUnreachable(paymentMethod);
   }
};
